import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { FaCircleXmark } from "react-icons/fa6";
import { Button, Input } from "../CustomComponents";
import LoadingButton from "../CustomComponents/LoadingButton";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import PhoneInput from "react-phone-input-2";

const AddSuperVisorModal = ({
  handleClose,
  data,
  imagePreview,
  setImagePreview,
  setFinalImage,
  finalImage,
  onSubmit,
  isLoadingSubmit,
  learningMatData,
  control,
  handleSubmit,
  setValue,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "links",
  });
  const addLinks = () => append({ title: "", link: "" });

  const removeLinks = (index) => {
    if (fields.length > 1) {
      remove(index);
    }
  };

  useEffect(() => {
    if (data) {
      setValue("username", data.username);
      setValue("firstname", data.firstname);
      setValue("lastname", data.lastname);
      setValue("mobile_no", data.mobile_no);
      setValue("password", data.password);
      setValue("confirm_password", data.confirm_password);
    }
  }, [data]);

  return (
    <div>
      <ModalContainer handleClose={handleClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0">
              {data ? "Update" : "Add"} Supervisor
            </p>
            <FaCircleXmark
              onClick={handleClose}
              style={{ cursor: "pointer" }}
            />
          </div>
          <Form className="w-100" onSubmit={handleSubmit(onSubmit)}>
            <div className="mt-3">
              <p className="m-0">Name</p>
              <div className="d-flex align-items-center gap-3 justify-content-between">
                <Controller
                  control={control}
                  name="firstname"
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Input
                      classes="mt-2 mb-3"
                      type="text"
                      placeholder="Enter First Name"
                      value={value}
                      onChange={onChange}
                      //   minLength={4}
                      //   maxLength={4}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="lastname"
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Input
                      classes="mt-2 mb-3"
                      type="text"
                      placeholder="Enter Last Name"
                      value={value}
                      onChange={onChange}
                      //   minLength={4}
                      //   maxLength={4}
                    />
                  )}
                />
              </div>
            </div>
            <div className="mt-3">
              <p className="m-0">User Name</p>
              <Controller
                control={control}
                name="username"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <Input
                    classes="mt-2 mb-3"
                    type="text"
                    placeholder="User Name"
                    disable={data && true}
                    value={value}
                    onChange={onChange}
                    //   minLength={4}
                    //   maxLength={4}
                  />
                )}
              />
            </div>
            <div className="mt-3 mb-3">
              <Controller
                control={control}
                name="mobile_no"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <PhoneInput
                    country={"us"}
                    value={value}
                    disabled={data && true}
                    onChange={onChange}
                    className="phone-input"
                  />
                )}
              />
            </div>
            {!data && (
              <>
                <div className="mt-3">
                  <p className="m-0">Password</p>
                  <Controller
                    control={control}
                    name="password"
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        classes="mt-2 mb-3"
                        type="text"
                        placeholder="Password"
                        value={value}
                        onChange={onChange}
                        //   minLength={4}
                        //   maxLength={4}
                      />
                    )}
                  />
                </div>
                <div className="mt-3">
                  <p className="m-0">Confirm Password</p>
                  <Controller
                    control={control}
                    name="confirm_password"
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        classes="mt-2 mb-3"
                        type="text"
                        placeholder="Cnfirm Password"
                        value={value}
                        onChange={onChange}
                        //   minLength={4}
                        //   maxLength={4}
                      />
                    )}
                  />
                </div>
              </>
            )}
            <div className={`w-100 ${cssStyles.saveButton}`}>
              <Button
                text={
                  isLoadingSubmit ? <LoadingButton /> : data ? "Update" : "Add"
                }
                classes="fs-6 mb-2 mt-3 mt-auto"
                type="submit"
                disabled={isLoadingSubmit}
              />
            </div>
          </Form>
        </div>
      </ModalContainer>
    </div>
  );
};

export default AddSuperVisorModal;
